import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { createNoDashGuid } from "../../../src/common/Guid";
import { ChunkedArrayBufferStream, PromiseHelper } from "../../common/Exports";
import { AudioStreamFormatImpl } from "./AudioStreamFormat";
export var bufferSize = 4096;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @class AudioInputStream
 */

export var AudioOutputStream = /*#__PURE__*/function () {
  /**
   * Creates and initializes an instance.
   * @constructor
   */
  function AudioOutputStream() {
    _classCallCheck(this, AudioOutputStream);
  }
  /**
   * Creates a memory backed PullAudioOutputStream with the specified audio format.
   * @member AudioInputStream.createPullStream
   * @function
   * @public
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   *        written to the push audio stream's write() method (currently only support 16 kHz 16bit mono PCM).
   * @returns {PullAudioOutputStream} The audio input stream being created.
   */


  _createClass(AudioOutputStream, null, [{
    key: "createPullStream",
    value: function createPullStream(format) {
      return PullAudioOutputStream.create(format);
    }
  }]);

  return AudioOutputStream;
}();
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @class PullAudioOutputStream
 */
// tslint:disable-next-line:max-classes-per-file

export var PullAudioOutputStream = /*#__PURE__*/function (_AudioOutputStream) {
  _inherits(PullAudioOutputStream, _AudioOutputStream);

  function PullAudioOutputStream() {
    _classCallCheck(this, PullAudioOutputStream);

    return _possibleConstructorReturn(this, _getPrototypeOf(PullAudioOutputStream).apply(this, arguments));
  }

  _createClass(PullAudioOutputStream, null, [{
    key: "create",

    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member PullAudioOutputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     *        push audio stream's write() method (currently only support 16 kHz 16bit mono PCM).
     * @returns {PullAudioOutputStream} The push audio input stream being created.
     */
    value: function create(format) {
      return new PullAudioOutputStreamImpl(bufferSize, format);
    }
  }]);

  return PullAudioOutputStream;
}(AudioOutputStream);
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @private
 * @class PullAudioOutputStreamImpl
 */
// tslint:disable-next-line:max-classes-per-file

export var PullAudioOutputStreamImpl = /*#__PURE__*/function (_PullAudioOutputStrea) {
  _inherits(PullAudioOutputStreamImpl, _PullAudioOutputStrea);

  /**
   * Creates and initalizes an instance with the given values.
   * @constructor
   * @param {AudioStreamFormat} format - The audio stream format.
   */
  function PullAudioOutputStreamImpl(chunkSize, format) {
    var _this;

    _classCallCheck(this, PullAudioOutputStreamImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PullAudioOutputStreamImpl).call(this));

    if (format === undefined) {
      _this.privFormat = AudioStreamFormatImpl.getDefaultInputFormat();
    } else {
      _this.privFormat = format;
    }

    _this.privId = createNoDashGuid();
    _this.privStream = new ChunkedArrayBufferStream(chunkSize);
    _this.streamReader = _this.privStream.getReader();
    return _this;
  }
  /**
   * Format information for the audio
   */


  _createClass(PullAudioOutputStreamImpl, [{
    key: "read",

    /**
     * Reads data from the buffer
     * @member PullAudioOutputStreamImpl.prototype.read
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */
    value: function read() {
      return this.streamReader.read().onSuccessContinueWithPromise(function (chunk) {
        return PromiseHelper.fromResult(chunk.buffer);
      });
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PullAudioOutputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */

  }, {
    key: "write",
    value: function write(dataBuffer) {
      this.privStream.writeStreamChunk({
        buffer: dataBuffer,
        isEnd: false,
        timeReceived: Date.now()
      });
    }
    /**
     * Closes the stream.
     * @member PullAudioOutputStreamImpl.prototype.close
     * @function
     * @public
     */

  }, {
    key: "close",
    value: function close() {
      this.privStream.close();
    }
  }, {
    key: "format",
    get: function get() {
      return this.privFormat;
    }
    /**
     * Checks if the stream is closed
     * @member PullAudioOutputStreamImpl.prototype.isClosed
     * @property
     * @public
     */

  }, {
    key: "isClosed",
    get: function get() {
      return this.privStream.isClosed;
    }
    /**
     * Gets the id of the stream
     * @member PullAudioOutputStreamImpl.prototype.id
     * @property
     * @public
     */

  }, {
    key: "id",
    get: function get() {
      return this.privId;
    }
  }]);

  return PullAudioOutputStreamImpl;
}(PullAudioOutputStream);